import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: {
    selectedServices: [],
    servicePageData: {
      genderPreference: '',
      otherServices: '',
      services: [],
      selectedCarePlan: '',
    },
  },
}
